// Components
import SummaryItemFirstStep from '@/components/pages/giveaway-picker/GiveawayPickerWrapper/components/DrawSummary/components/steps/SummaryItemFirstStep';
import SummaryItemSecondStep from '@/components/pages/giveaway-picker/GiveawayPickerWrapper/components/DrawSummary/components/steps/SummaryItemSecondStep';
import SummaryItemThirdStep from '@/components/pages/giveaway-picker/GiveawayPickerWrapper/components/DrawSummary/components/steps/SummaryItemThirdStep';
export function DrawSummary() {
    return (
        <div
            className="flex w-full flex-col gap-8 overflow-y-auto rounded-2xl bg-icoGray-100 p-10 lg:w-[400px]"
            data-testid="draw-summary">
            <SummaryItemFirstStep />
            <SummaryItemSecondStep />
            <SummaryItemThirdStep />
        </div>
    );
}
